/* global Modernizr */

import { Controller } from 'stimulus';
import jump from 'jump.js';
import hasHistorySupport from '@/helpers/hasHistorySupport';
import serializeFormToObject from '@/helpers/serializeFormToObject';

const isDesktop = () => Modernizr.mq('(min-width: 1200px)');

class FiltersController extends Controller {
  connect() {
    this.isFixed = false;

    this.onFilterChange();
    this.onWindowScroll();

    $(this.element).on('click', '.pagination a', (e) => {
      e.preventDefault();

      const pageNumber = parseInt(e.currentTarget.getAttribute('data-page') || 1, 10);

      this.setPageNumber(pageNumber);
      this.scrollToTop();
      this.onFilterChange(false);
    });

    window.addEventListener('resize', this.onWindowScroll.bind(this));
    window.addEventListener('scroll', this.onWindowScroll.bind(this));
  }

  destroy() {
    window.removeEventListener('resize', this.onWindowScroll.bind(this));
    window.removeEventListener('scroll', this.onWindowScroll.bind(this));
  }

  onFilterChange(resetPage = true) {
    const formData = serializeFormToObject(this.formTarget);

    if (resetPage) {
      formData.page = 1;
    }

    this.fetchPage(formData)
      .then((res) => {
        if (typeof res.results !== 'undefined') {
          this.outputResults(res.results);
        }

        if (typeof res.resultsCount !== 'undefined') {
          this.outputResultsCount(res.resultsCount);
        }

        if (typeof res.queryString !== 'undefined') {
          this.outputQueryString(res.queryString);
        }
      });
  }

  fetchPage(formData) {
    return new Promise((resolve, reject) => {
      const formUrl = this.formTarget.action;

      $.ajax({
        url: formUrl,
        data: formData,
        success: resolve,
        error: reject,
      });
    });
  }

  setPageNumber(page) {
    if (!this.hasPageNumberTarget) return;

    this.pageNumberTarget.value = page;
  }

  outputResults(results) {
    this.runOffMainThread(() => {
      this.resultsTarget.innerHTML = results;
    });
  }

  // eslint-disable-next-line class-methods-use-this
  runOffMainThread(cb) {
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(() => {
        requestAnimationFrame(cb);
      });

      return;
    }

    setTimeout(cb);
  }

  // eslint-disable-next-line class-methods-use-this
  outputQueryString(queryString) {
    if (!hasHistorySupport()) {
      return;
    }

    window.history.replaceState(null, null, `?${queryString}`);
  }

  outputResultsCount(count) {
    const suffix = count === 1
      ? this.resultsCountTarget.getAttribute('data-suffix-singular')
      : this.resultsCountTarget.getAttribute('data-suffix-plural');

    this.resultsCountTarget.innerHTML = `${count} ${suffix}`;
  }

  onWindowScroll() {
    const top = this.element.offsetTop;
    const { scrollY } = window;
    let headerHeight = document.querySelector('.js-header').offsetHeight;

    if (isDesktop()) {
      headerHeight -= 56;
    }

    if (scrollY >= (top - headerHeight) && !this.isFixed) {
      this.isFixed = true;
      this.setFixedState();
    } else if (scrollY < (top - headerHeight) && this.isFixed) {
      this.isFixed = false;
      this.setFixedState();
    }
  }

  setFixedState() {
    this.formTarget.classList[this.isFixed ? 'add' : 'remove']('is-fixed');
  }

  reset() {
    this.filterTargets.forEach((filter) => {
      filter.value = '';
    });

    this.onFilterChange();
  }

  scrollToTop() {
    jump(this.element, {
      offset: isDesktop() ? -150 : -60,
      a11y: false,
    });
  }
}

FiltersController.targets = [
  'form',
  'filter',
  'results',
  'resultsCount',
  'queryString',
  'pageNumber',
];

export default FiltersController;
